import moment from 'moment';
import { R$ } from 'shared/helpers/currency';
import { Discount, DiscountType } from './discount';
import { IPlan, Plan } from './plan';

export interface IProduct {
  id?: number;
  name?: string;
  service?: IPlan;
  plans?: IPlan[];
  price?: string;
  original_price?: string;
  is_license?: boolean;
  discount_value?: number;
  discount_cycles?: number;
  discount_type?: DiscountType;
  created_at?: string;
  deleted_at?: string;
}

export class Product {
  id?: number;
  name?: string;
  plan?: Plan;
  discount?: Discount;
  plans: Plan[] = [];
  value: number = 0;

  isLicense: boolean = false;

  discount_value?: number;

  created_at?: moment.Moment;
  deleted_at?: moment.Moment;

  constructor(data?: IProduct) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.isLicense = data.is_license || false;
      this.discount_value = data.discount_value || 0;

      if (data.price) this.value = Number(data.price);

      if (data.service) this.plan = new Plan(data.service);

      this.discount = new Discount({
        discount_value: data.discount_value ?? undefined,
        discount_type: data.discount_type,
        cycles: data.discount_cycles,
        product_total_value: data.original_price
          ? Number(data.original_price)
          : undefined,
        product_value_with_discount: data.price
          ? Number(data.price)
          : undefined,
      });

      if (data.plans)
        data.plans.forEach((plan) => this.plans.push(new Plan(plan)));

      if (data.created_at) {
        this.created_at = moment(data.created_at);
      }

      if (data.deleted_at) {
        this.deleted_at = moment(data.deleted_at);
      }
    }
  }

  /**
   * @deprecated Remover esse método e consertar lógica dependente dele
   * Está sendo usado como lógica de contract_service
   */
  get priceString() {
    return R$(this.value);
  }
}
